import React from 'react';

export default function ChevronRight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="chevron_right"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      width={props.width ?? '20'}
      height={props.height ?? '20'}
      {...props}
    >
      <rect id="Box" width="20" height="20" fill="none" />
      <path
        id="Vector"
        d="M0,9.467,4.72,4.733,0,0"
        transform="translate(7.641 5.266)"
        fill="none"
        stroke={props.stroke ?? '#dc4405'}
        strokeLinecap="round"
        strokeWidth="1.7"
      />
    </svg>
  );
}
